import { useLang } from "@/components/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();

  return (
    <div className="flex items-center gap-1 bg-white/10 backdrop-blur-sm border border-white/30 rounded-full p-1">
      <button
        onClick={() => setLang("es")}
        className={`px-3 py-1 rounded-full text-xs font-bold transition-all duration-200 ${
          lang === "es"
            ? "bg-green-500 text-white shadow"
            : "text-white/70 hover:text-white"
        }`}
      >
        ES
      </button>
      <button
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full text-xs font-bold transition-all duration-200 ${
          lang === "en"
            ? "bg-green-500 text-white shadow"
            : "text-white/70 hover:text-white"
        }`}
      >
        EN
      </button>
    </div>
  );
}